<template>
  <div class="part-item projectBuilding">
    <p class="part-title">诚信承诺
    </p>
    <div class="part-content">
      <p>本团队承诺：申报课程的实验教学设计具有一定的原创性，课程所属学校对本实验课程内容（包括但不限于实验软件、操作系统、教学视频、教学课件、辅助参考资料、实验操作手册、实验案例、测验试题、实验报告、答疑、网页宣传图片文字等组成本实验课程的一切资源）享有著作权，保证所申报的课程或其任何一部分均不会侵犯任何第三方的合法权益。</p>
      <p class="fangsong commitment-incharge">实验教学课程负责人（签字）：
        <img
          class="signPic"
          :src="formInfo.promise_file.path"
          alt=""
        >
      </p>
      <p class="fangsong commitment-year">
        {{formatTime(formInfo.promise_file.date)}}
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SincerityPromise',
  props: ['expId'],
  data () {
    return {
      formInfo: {
        promise_file: ''
      }
    }
  },
  methods: {
    formatTime(val) {
      if (val) {
        const valIndex = val.indexOf('T')
        const newStr = val.slice(0, valIndex)
        const valArr = newStr.split('-')
        return valArr[0] + '年' + valArr[1] + '月' + valArr[2] + '日'
      } else {
        return ' 年' + ' 月' + ' 日'
      }
    },

    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.promise_file = data.promise_file ? JSON.parse(data.promise_file) : ''
      }).catch((error) => {
        console.log(error)
      })
    }

  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.commitment-incharge {
  text-align: right;
  margin-top: 10px;
}
.commitment-year {
  text-align: right;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
</style>
